(() => {
  const hydrateCard = (target) => {
    if (!(target instanceof Element)) return;
    const card = target.closest('.card-wrapper');
    if (!card) return;

    card.querySelectorAll('img[data-secondary-image]').forEach((image) => {
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      if (image.dataset.src) image.src = image.dataset.src;
      image.removeAttribute('data-src');
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-secondary-image');
    });
  };

  document.addEventListener('pointerover', (event) => hydrateCard(event.target), { passive: true });
  document.addEventListener('focusin', (event) => hydrateCard(event.target));
})();
